// Popups team
document.querySelectorAll('.open-popup-button').forEach(item => {
    item.addEventListener('click', event => {
        let partnerPopupContainer = document.getElementById(item.dataset.id + '-popup');
        partnerPopupContainer.classList.toggle('hidden');
        document.getElementsByTagName('body')[0].classList.add('overflow-hidden');
    })
})

document.querySelectorAll('.close-popup-button').forEach(item => {
    item.addEventListener('click', event => {
        let partnerPopupContainer = document.getElementById(item.dataset.id + '-popup');
        partnerPopupContainer.classList.toggle('hidden');
        document.getElementsByTagName('body')[0].classList.remove('overflow-hidden');
    })
})

// Popups partenaires
document.querySelectorAll('.open-partner-popup-button').forEach(item => {
    item.addEventListener('click', event => {
        let partnerPopupContainer = document.getElementById(item.dataset.id + '-partner-popup');
        partnerPopupContainer.classList.toggle('hidden');
    })
})

document.querySelectorAll('.close-partner-popup-button').forEach(item => {
    item.addEventListener('click', event => {
        let partnerPopupContainer = document.getElementById(item.dataset.id + '-partner-popup');
        partnerPopupContainer.classList.toggle('hidden');
    })
})

// Popups lead magnet
document.querySelectorAll('.open-lead-magnet-popup-button').forEach(item => {
    item.addEventListener('click', event => {
        let leadMagnetPopupContainer = document.getElementById(item.dataset.id + '-lead-magnet-popup');
        leadMagnetPopupContainer.classList.toggle('hidden');
    })
})

document.querySelectorAll('.close-lead-magnet-popup-button').forEach(item => {
    item.addEventListener('click', event => {
        let leadMagnetPopupContainer = document.getElementById(item.dataset.id + '-lead-magnet-popup');
        leadMagnetPopupContainer.classList.toggle('hidden');
    })
})

// Popups gallery
const galleryPopupContainer = document.getElementById('gallery-popup');
const image = document.getElementById('gallery-popup-image');
const alt = document.getElementById('gallery-popup-alt');

document.querySelectorAll('.gallery-popup-open-button').forEach(item => {
    item.addEventListener('click', event => {
        galleryPopupContainer.classList.toggle('hidden');
        image.innerHTML = '<img src="' + event.target.getAttribute("data-full-picture") + '" class="aspect-auto max-h-screen p-2" />'
        alt.innerHTML = event.target.alt
    })
})

document.querySelectorAll('.gallery-popup-close-button').forEach(item => {
    item.addEventListener('click', event => {
        galleryPopupContainer.classList.toggle('hidden');
    })
})
